import { render, staticRenderFns } from "./LinkInsertionsPopup.vue?vue&type=template&id=305b5518&scoped=true"
import script from "./LinkInsertionsPopup.vue?vue&type=script&lang=js"
export * from "./LinkInsertionsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305b5518",
  null
  
)

export default component.exports